import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck, Download, ArrowRight } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 bg-earth-darker text-cream relative overflow-hidden" data-id="element-114">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-3xl" data-id="element-115" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-116">
        <FadeIn data-id="element-117">
          <div className="inline-block bg-white/10 backdrop-blur-md px-6 py-2 rounded-full border border-white/20 mb-8" data-id="element-118">
            <span className="text-accent font-semibold tracking-wider uppercase text-sm" data-id="element-119">
              Oferta de lanzamiento por tiempo limitado
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-120">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-white" data-id="element-121">
            ACCESO INMEDIATO POR SOLO
          </h2>

          <div className="flex items-center justify-center gap-6 mb-12" data-id="element-122">
            <span className="text-3xl md:text-4xl text-cream-dark/50 line-through font-serif" data-id="element-123">
              $47 USD
            </span>
            <span className="text-6xl md:text-7xl font-bold text-accent font-serif" data-id="element-124">
              $27 USD
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-125">
          <div className="max-w-xl mx-auto" data-id="element-126">
            <a href="https://vitalizateahora.com/cart/51934597447911:1" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 w-full bg-accent hover:bg-accent-hover text-white px-8 py-6 rounded-full font-semibold text-xl md:text-2xl shadow-xl shadow-accent/20 transition-colors duration-300 mb-8" data-id="element-127">
              <span data-id="element-128">¡SÍ! QUIERO CALMAR A MI BEBÉ AHORA</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-129" />
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-cream-dark/80 text-sm md:text-base" data-id="element-130">
              <div className="flex items-center gap-2" data-id="element-131">
                <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-132" />
                <span data-id="element-133">Pago seguro y encriptado</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-cream-dark/30 rounded-full" data-id="element-134" />
              <div className="flex items-center gap-2" data-id="element-135">
                <Download className="w-5 h-5 text-accent" data-id="element-136" />
                <span data-id="element-137">Descarga digital instantánea</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}